//アコーディオン
/*使い方
アコーディオンさせたいクリック要素に.acc-toggleを付与。その直下の要素が開閉する要素になります。
*/
$(function() {
  
if ($('.acc-toggle').length) {
  function accordionAll() {
    $(this).toggleClass("active").next().slideToggle();
  }
  $(".acc-toggle").click(accordionAll);
}

  
//商品詳細 サイズリンクのスムーススクロール
if ($('#custum-swatch').length) {
$('#custum-swatch a[href^="#"]').on('click',function () {
  var speed = 800;
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top - 80;
  $("html, body").animate({
    scrollTop: position
  }, speed, "swing");
  return false;
});
}
  
  
});